/**
 * BUILD LIST — Metafield Only, Variant-Aware
 * ============================================
 * READ:  window.__buildListSeed (Liquid-rendered)
 * WRITE: POST to PHP endpoint → Shopify Admin API
 */

(function () {
  'use strict';

  var SAVE_ENDPOINT = 'https://scripts.tegiwa.de/tegiwa-build-list/buildlist-save.php';

  var wishlistItems = [];
  var customerId = window.__buildListCustomerId || null;
  var isLoggedIn = !!customerId;
  var saveDebounceTimer = null;
  var MIN_SPINNER_MS = 2000;
  var spinnerStartTime = Date.now();
  var initialLoadComplete = false;

  function normalizeItems(raw) {
    if (!Array.isArray(raw)) {
      if (typeof raw === 'string') {
        try { raw = JSON.parse(raw); } catch (e) { return []; }
        if (!Array.isArray(raw)) return [];
      } else {
        return [];
      }
    }
    return raw.map(function (item) {
      if (typeof item === 'string') return { handle: item, variantId: null, qty: 1 };
      return {
        handle: item.handle,
        variantId: item.variantId ? Number(item.variantId) : null,
        qty: item.qty || 1,
      };
    });
  }

  function findItem(handle, variantId) {
    return wishlistItems.find(function (item) {
      if (variantId) return item.handle === handle && String(item.variantId) === String(variantId);
      return item.handle === handle;
    });
  }

  // ─── Save to PHP ─────────────────────────────────────
  function saveToServer(items, immediate) {
    if (!isLoggedIn || !customerId) return;
    if (!immediate) {
      clearTimeout(saveDebounceTimer);
      saveDebounceTimer = setTimeout(function () { doSave(items); }, 400);
      return;
    }
    doSave(items);
  }

  function doSave(items) {
    fetch(SAVE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, items: items }),
    }).catch(function () {});
  }

  // ─── Mini-Cart Refresh ───────────────────────────────
  function refreshCartSection() {
    var url = window.location.origin + '/cart?section_id=mini-cart';
    fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
      headers: { 'Cache-Control': 'no-cache' },
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        tempDiv = tempDiv.firstElementChild;
        var newCount = tempDiv.firstElementChild
          ? tempDiv.firstElementChild.getAttribute('data-item-count')
          : null;
        if (newCount) {
          var el = document.querySelector('.header__cart-count');
          if (el) el.textContent = newCount;
        }
        var currentMiniCart = document.querySelector('#mini-cart');
        var newMiniCart = tempDiv.querySelector('.mini-cart');
        if (currentMiniCart && newMiniCart) {
          var list = currentMiniCart.querySelector('.mini-cart__line-item-list');
          var scroll = list ? list.scrollTop : 0;
          currentMiniCart.innerHTML = newMiniCart.innerHTML;
          var newList = currentMiniCart.querySelector('.mini-cart__line-item-list');
          if (newList && scroll) newList.scrollTop = scroll;
          var cartEl = document.querySelector('.header__action-item--cart');
          if (cartEl) cartEl.dispatchEvent(new CustomEvent('cart:rerendered'));
        }
      })
      .catch(function () {});
  }

  // ─── Load ────────────────────────────────────────────
  function loadWishlist() {
    spinnerStartTime = Date.now();
    var loadingEl = document.getElementById('wishlist-loading');
    if (loadingEl) loadingEl.style.display = 'flex';

    if (isLoggedIn) {
      var seed = window.__buildListSeed;
      if (typeof seed === 'string') {
        try { seed = JSON.parse(seed); } catch (e) { seed = []; }
      }
      wishlistItems = normalizeItems(seed || []);
    } else {
      wishlistItems = [];
    }
    updateAllButtons();
    renderWishlistPage();
  }

  // ─── CRUD ────────────────────────────────────────────
  function addItem(handle, variantId, qty) {
    if (!isLoggedIn) { showToast('Log in to use your Build List'); return; }
    qty = qty || 1;
    variantId = variantId ? Number(variantId) : null;
    var existing = findItem(handle, variantId);
    if (existing) {
      existing.qty = qty;
    } else {
      wishlistItems.push({ handle: handle, variantId: variantId, qty: qty });
    }
    saveToServer(wishlistItems, true);
    updateAllButtons();
    showToast('Added to Build List', 'https://www.tegiwa.com/pages/your-build-list', 'View Build List');
  }

  function removeItem(handle, variantId) {
    wishlistItems = wishlistItems.filter(function (item) {
      if (variantId) return !(item.handle === handle && String(item.variantId) === String(variantId));
      return item.handle !== handle;
    });
    saveToServer(wishlistItems, true);
    updateAllButtons();
    renderWishlistPage();
    showToast('Removed from Build List');
  }

  function updateItemQty(handle, variantId, qty) {
    var item = findItem(handle, variantId);
    if (item) {
      item.qty = Math.max(1, qty);
      saveToServer(wishlistItems, false);
    }
  }

  function clearAll() {
    wishlistItems = [];
    saveToServer(wishlistItems, true);
    updateAllButtons();
    renderWishlistPage();
    showToast('Build List cleared');
  }

  function toggleItem(handle, variantId) {
    variantId = variantId ? Number(variantId) : null;
    if (findItem(handle, variantId)) {
      removeItem(handle, variantId);
    } else {
      addItem(handle, variantId, 1);
    }
  }

  // ─── Cart API ────────────────────────────────────────
  async function addToCart(variantId, qty) {
    qty = qty || 1;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
      });
      if (!res.ok) throw new Error('Cart add failed');
      showToast('Added to cart');
      refreshCartSection();
      return true;
    } catch (e) {
      showToast('Could not add to cart');
      return false;
    }
  }

  async function addAllToCart() {
    var grid = document.getElementById('wishlist-grid');
    var cards = grid ? grid.querySelectorAll('.wishlist-card') : [];
    var items = [];
    var addedHandles = [];

    cards.forEach(function (card) {
      var selectBox = card.querySelector('.wishlist-card__select');
      if (!selectBox || !selectBox.checked) return;
      var variantId = card.dataset.variantId;
      var handle = card.dataset.productHandle;
      var qtyInput = card.querySelector('.wishlist-qty-input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (variantId) {
        items.push({ id: parseInt(variantId, 10), quantity: qty });
        addedHandles.push({ handle: handle, variantId: variantId });
      }
    });

    if (items.length === 0) { showToast('No parts selected'); return; }

    var btn = document.getElementById('wishlist-add-all');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!res.ok) throw new Error('Cart add failed');
      showToast('Added ' + items.length + ' part' + (items.length !== 1 ? 's' : '') + ' to cart');
      refreshCartSection();

      // Remove added items from build list
      addedHandles.forEach(function (item) {
        wishlistItems = wishlistItems.filter(function (wl) {
          return !(wl.handle === item.handle && String(wl.variantId) === String(item.variantId));
        });
      });
      saveToServer(wishlistItems, true);
      updateAllButtons();
      renderWishlistPage();
    } catch (e) {
      showToast('Could not add parts to cart');
      if (btn) { btn.disabled = false; updateSelectionCount(); }
    }
  }

  // ─── UI: Toggle Buttons ─────────────────────────────
  var BUILD_LIST_URL = 'https://www.tegiwa.com/pages/your-build-list';

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.dataset.productHandle;

      // Count how many of THIS product are in the list (could be multiple variants)
      var itemQty = 0;
      wishlistItems.forEach(function (item) {
        if (item.handle === handle) itemQty += item.qty;
      });

      var isActive = itemQty > 0;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive);

      var label = btn.querySelector('[data-label-add]');
      if (label) {
        if (isActive) {
          label.innerHTML = itemQty + ' in Build List — <a href="' + BUILD_LIST_URL + '" class="wishlist-btn__view-link">View Now</a>';
        } else {
          label.textContent = label.dataset.labelAdd;
        }
      }
    });
  }

  // ─── UI: Build List Page ────────────────────────────
  async function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    var counter = document.getElementById('wishlist-count');
    var headerActions = document.getElementById('wishlist-header-actions');

    if (!grid) { renderLoadingState(false); return; }
    grid.innerHTML = '';

    // Keep everything hidden while spinner is up
    grid.style.display = 'none';
    if (empty) empty.style.display = 'none';
    if (headerActions) headerActions.style.display = 'none';

    if (!isLoggedIn) {
      if (counter) counter.textContent = '';
      renderLoadingState(false, function () {
        empty.style.display = 'flex';
        empty.querySelector('.wishlist-empty__title').textContent = 'Log in to view your Build List';
        empty.querySelector('.wishlist-empty__text').textContent = 'Your build list is saved to your account so you can access it from any device.';
        var cta = empty.querySelector('.wishlist-empty__cta');
        if (cta) { cta.href = '/account/login'; cta.textContent = 'Log In'; }
      });
      return;
    }

    if (wishlistItems.length === 0) {
      if (counter) counter.textContent = '0 parts';
      renderLoadingState(false, function () {
        empty.style.display = 'flex';
      });
      return;
    }

    if (counter)
      counter.textContent = wishlistItems.length + ' part' + (wishlistItems.length !== 1 ? 's' : '');

    // Build all cards into a fragment while spinner is still showing
    var fragment = document.createDocumentFragment();
    var anyLoaded = false;

    for (var i = 0; i < wishlistItems.length; i++) {
      var wlItem = wishlistItems[i];
      try {
        var res = await fetch('/products/' + wlItem.handle + '.js');
        if (!res.ok) continue;
        var product = await res.json();
        var card = createProductCard(product, wlItem);
        fragment.appendChild(card);
        anyLoaded = true;
      } catch (e) {}
    }

    // Only reveal grid + cards when the spinner actually goes away
    renderLoadingState(false, function () {
      if (!anyLoaded) {
        if (empty) empty.style.display = 'flex';
        return;
      }
      grid.appendChild(fragment);
      grid.style.display = 'grid';
      if (headerActions) headerActions.style.display = 'flex';

      requestAnimationFrame(function () {
        grid.querySelectorAll('.wishlist-card').forEach(function (card, idx) {
          card.style.animationDelay = idx * 0.07 + 's';
          card.classList.add('wishlist-card--visible');
        });
      });
    });
  }

  function createProductCard(product, wlItem) {
    var template = document.getElementById('wishlist-card-template');
    var clone = template.content.cloneNode(true);
    var card = clone.querySelector('.wishlist-card');

    var variant = null;
    if (wlItem.variantId) {
      variant = product.variants.find(function (v) {
        return String(v.id) === String(wlItem.variantId);
      });
    }
    if (!variant) variant = product.variants[0];

    card.dataset.productHandle = product.handle;
    card.dataset.variantId = variant.id;

    var img = card.querySelector('.wishlist-card__image');
    var imageUrl = variant.featured_image ? variant.featured_image.src : product.featured_image;
    if (imageUrl) {
      img.src = resizeImage(imageUrl, '600x');
      img.alt = product.title;
    }

    var url = '/products/' + product.handle + '?variant=' + variant.id;
    card.querySelector('.wishlist-card__image-link').href = url;
    card.querySelector('.wishlist-card__title').href = url;

    var vendorEl = card.querySelector('.wishlist-card__vendor');
    if (product.vendor) {
      vendorEl.textContent = product.vendor;
      vendorEl.href = '/collections/' + slugify(product.vendor);
    } else {
      vendorEl.style.display = 'none';
    }

    var title = product.title;
    if (variant.title && variant.title !== 'Default Title') {
      title += ' — ' + variant.title;
    }
    card.querySelector('.wishlist-card__title').textContent = title;

    var skuEl = card.querySelector('.wishlist-card__sku');
    if (variant.sku) {
      skuEl.textContent = variant.sku;
    } else {
      skuEl.style.display = 'none';
    }

    var priceEl = card.querySelector('.wishlist-card__price');
    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var compareEl = card.querySelector('.wishlist-card__compare-price');
      compareEl.textContent = formatMoney(variant.compare_at_price);
      compareEl.style.display = 'inline';
      priceEl.classList.add('price--highlight');
    }

    var qtyInput = card.querySelector('.wishlist-qty-input');
    qtyInput.value = wlItem.qty || 1;

    card.querySelector('.wishlist-card__select').addEventListener('change', function () {
      updateSelectionCount();
    });

    card.querySelector('.wishlist-card__remove').addEventListener('click', function (e) {
      e.preventDefault();
      card.classList.add('wishlist-card--removing');
      card.addEventListener('animationend', function () {
        removeItem(product.handle, variant.id);
      }, { once: true });
    });

    card.querySelector('[data-action="wishlist-add-to-cart"]').addEventListener('click', function () {
      var currentQty = parseInt(qtyInput.value, 10) || 1;
      var self = this;
      self.disabled = true;
      self.textContent = 'Adding...';
      addToCart(variant.id, currentQty).then(function (success) {
        if (success) {
          card.classList.add('wishlist-card--removing');
          card.addEventListener('animationend', function () {
            removeItem(product.handle, variant.id);
          }, { once: true });
        } else {
          self.disabled = false;
          self.textContent = 'Add to cart';
        }
      });
    });

    card.querySelector('[data-action="wishlist-decrease-qty"]').addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) { val--; qtyInput.value = val; updateItemQty(product.handle, variant.id, val); }
    });
    card.querySelector('[data-action="wishlist-increase-qty"]').addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      val++; qtyInput.value = val; updateItemQty(product.handle, variant.id, val);
    });
    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      qtyInput.value = val;
      updateItemQty(product.handle, variant.id, val);
    });

    return clone;
  }

  // ─── Selection ──────────────────────────────────────
  function updateSelectionCount() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var all = grid.querySelectorAll('.wishlist-card__select');
    var checked = grid.querySelectorAll('.wishlist-card__select:checked');
    var btn = document.getElementById('wishlist-add-all');
    var clearBtn = document.getElementById('wishlist-clear-all');
    var selectAllBox = document.getElementById('wishlist-select-all');

    if (btn) {
      var count = checked.length;
      btn.disabled = count === 0;
      var label = count === all.length ? 'Add All to Cart' : 'Add Selected to Cart (' + count + ')';
      btn.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> ' + label;
    }
    if (clearBtn) {
      var hasSelection = checked.length > 0 && checked.length < all.length;
      var clearLabel = hasSelection ? 'Clear Selected (' + checked.length + ')' : 'Clear All';
      clearBtn.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg> ' + clearLabel;
    }
    if (selectAllBox) {
      selectAllBox.checked = checked.length === all.length && all.length > 0;
    }
  }

  function removeSelected() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var checked = grid.querySelectorAll('.wishlist-card__select:checked');
    var toRemove = [];
    checked.forEach(function (cb) {
      var card = cb.closest('.wishlist-card');
      if (card) {
        toRemove.push({
          handle: card.dataset.productHandle,
          variantId: card.dataset.variantId,
        });
      }
    });
    toRemove.forEach(function (item) {
      wishlistItems = wishlistItems.filter(function (wl) {
        if (item.variantId) return !(wl.handle === item.handle && String(wl.variantId) === String(item.variantId));
        return wl.handle !== item.handle;
      });
    });
    saveToServer(wishlistItems, true);
    updateAllButtons();
    renderWishlistPage();
    showToast('Removed ' + toRemove.length + ' part' + (toRemove.length !== 1 ? 's' : ''));
  }

  // ─── Toast ──────────────────────────────────────────
  function showToast(message, linkUrl, linkText) {
    var toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.className = 'wishlist-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toast.appendChild(span);

    if (linkUrl && linkText) {
      var a = document.createElement('a');
      a.href = linkUrl;
      a.textContent = linkText;
      a.className = 'wishlist-toast__link';
      toast.appendChild(a);
    }

    toast.classList.remove('wishlist-toast--visible');
    void toast.offsetWidth;
    toast.classList.add('wishlist-toast--visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('wishlist-toast--visible');
    }, 4000);
  }

  var hidePending = false;
  function renderLoadingState(show, onHidden) {
    var el = document.getElementById('wishlist-loading');
    if (!el) { if (onHidden) onHidden(); return; }
    if (show) {
      el.style.display = 'flex';
      spinnerStartTime = Date.now();
      hidePending = false;
      return;
    }
    // After initial load, hide immediately with no delay
    if (initialLoadComplete) {
      el.style.display = 'none';
      if (onHidden) onHidden();
      return;
    }
    // Prevent duplicate hide scheduling during initial load
    if (hidePending) return;
    hidePending = true;
    var elapsed = Date.now() - spinnerStartTime;
    var remaining = Math.max(0, MIN_SPINNER_MS - elapsed);
    setTimeout(function () {
      el.style.display = 'none';
      initialLoadComplete = true;
      hidePending = false;
      if (onHidden) onHidden();
    }, remaining);
  }

  // ─── Helpers ─────────────────────────────────────────
  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }

  function resizeImage(url, size) {
    if (!url) return '';
    return url.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  function slugify(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function getVariantIdFromButton(btn) {
    var form = btn.closest('form[action*="/cart/add"]')
              || document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var input = form.querySelector('input[name="id"], select[name="id"]');
      if (input && input.value) return input.value;
    }
    return btn.dataset.variantId || null;
  }

  // ─── Event Delegation ───────────────────────────────
  document.addEventListener('click', function (e) {
    // Let "View Now" links navigate without toggling
    if (e.target.closest('.wishlist-btn__view-link')) return;

    var btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      var handle = btn.dataset.productHandle;
      var variantId = getVariantIdFromButton(btn);

      // If already in build list, navigate to the build list page
      var isActive = wishlistItems.some(function (item) {
        return item.handle === handle;
      });

      if (isActive) {
        window.location.href = BUILD_LIST_URL;
        return;
      }

      // Otherwise add to build list
      if (handle) addItem(handle, variantId, 1);
      btn.classList.add('wishlist-btn--pop');
      btn.addEventListener('animationend', function () {
        btn.classList.remove('wishlist-btn--pop');
      }, { once: true });
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#wishlist-clear-all')) {
      var grid = document.getElementById('wishlist-grid');
      var checked = grid ? grid.querySelectorAll('.wishlist-card__select:checked') : [];
      var all = grid ? grid.querySelectorAll('.wishlist-card__select') : [];

      if (checked.length > 0 && checked.length < all.length) {
        if (confirm('Remove ' + checked.length + ' selected part' + (checked.length !== 1 ? 's' : '') + ' from your build list?')) {
          removeSelected();
        }
      } else {
        if (confirm('Remove all parts from your build list?')) clearAll();
      }
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#wishlist-add-all')) addAllToCart();
  });

  document.addEventListener('change', function (e) {
    if (e.target.id === 'wishlist-select-all') {
      var checked = e.target.checked;
      var grid = document.getElementById('wishlist-grid');
      if (grid) {
        grid.querySelectorAll('.wishlist-card__select').forEach(function (cb) { cb.checked = checked; });
        updateSelectionCount();
      }
    }
  });

  // ─── Init ────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadWishlist);
  } else {
    loadWishlist();
  }

  window.Wishlist = {
    add: addItem,
    remove: removeItem,
    toggle: toggleItem,
    clear: clearAll,
    getItems: function () { return wishlistItems.slice(); },
    isInWishlist: function (handle, variantId) { return !!findItem(handle, variantId); },
    updateQty: updateItemQty,
  };
})();